import AskModal from 'components/common/AskModal';
import NotiModal from 'components/common/NotiModal';
import { PasswordLock } from 'lib/styles/icons';
import palette from 'lib/styles/palette';
import { useState } from 'react';
import styled from 'styled-components';
import { useMutation, useQueryClient } from 'react-query';
import { deleteMasterKid, updateMasterKidPassword } from 'lib/api/contract';
import useLoginCheck from 'hooks/common/useLoginCheck';

const ContractViewerMasterKidItem = ({ masterKid }) => {
  const queryClient = useQueryClient();

  const [showAskModal, setShowAskModal] = useState(false);

  const deleteMasterKidMutation = useMutation(deleteMasterKid, {
    onSuccess: () => {
      queryClient.invalidateQueries('contract');
    },
  });
  useLoginCheck(deleteMasterKidMutation.error?.response, () => {
    deleteMasterKidMutation.mutate(masterKid.id);
  });

  const updateMasterKidPasswordMutation = useMutation(updateMasterKidPassword, {
    onSuccess: () => {
      queryClient.invalidateQueries('contract');
    },
  });
  useLoginCheck(updateMasterKidPasswordMutation.error?.response, () => {
    updateMasterKidPasswordMutation.mutate(masterKid.id);
  });

  const onUpdateMasterKidPassword = () => {
    updateMasterKidPasswordMutation.mutate(masterKid.id);
  };

  const onDeleteMasterKid = () => {
    deleteMasterKidMutation.mutate(masterKid.id);
  };

  return (
    <>
      {deleteMasterKidMutation.error?.response.status === 500 && (
        <NotiModal
          closeModal={() => deleteMasterKidMutation.reset()}
          msg="서버 오류로 삭제에 실패했습니다"
          fontL
        />
      )}
      {updateMasterKidPasswordMutation.error?.response.status === 500 && (
        <NotiModal
          closeModal={() => updateMasterKidPasswordMutation.reset()}
          msg="서버 오류로 비밀번호 초기화에 실패했습니다"
          fontL
        />
      )}
      {updateMasterKidPasswordMutation.isSuccess && (
        <NotiModal
          closeModal={() => updateMasterKidPasswordMutation.reset()}
          msg="비밀번호 초기화 a1234567"
          fontL
        >
          <PasswordLock />
        </NotiModal>
      )}
      {showAskModal && (
        <AskModal
          closeModal={() => setShowAskModal(false)}
          action="삭제"
          message="정말로 삭제하시겠습니까?"
          actionFc={() => {
            setShowAskModal(false);
            onDeleteMasterKid(masterKid.id);
          }}
        />
      )}
      <ContractViewerMasterKidItemBlock>
        <div>{masterKid.userId}</div>
        <div>
          <StyledButton
            onClick={() => {
              onUpdateMasterKidPassword(masterKid.id);
            }}
          >
            초기화
          </StyledButton>
          <StyledButton onClick={() => setShowAskModal(true)}>
            삭제
          </StyledButton>
        </div>
      </ContractViewerMasterKidItemBlock>
    </>
  );
};

export default ContractViewerMasterKidItem;

const ContractViewerMasterKidItemBlock = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
`;

const StyledButton = styled.button`
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  background: ${palette.theme[3]};
  color: #fff;
  font-size: 8px;
  cursor: pointer;
  :hover {
    background: ${palette.theme[2]};
  }
  & + & {
    margin-left: 10px;
  }
`;
